import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ACCOUNT_ROLES } from 'src/constants/globalConstants';
import { PAGES } from 'src/constants/pages';
import { ACCESS_MODE, TUserWorkspace } from 'src/interfaces/workspacesReduxShapes';

const isRestrictedPath = (): boolean => {
  const restrictedViewerPaths = [PAGES.OPPORTUNITIES, PAGES.EDIT_ALLOCATION, PAGES.NEW_ALLOCATION];

  return restrictedViewerPaths.some((p) => {
    if (p === PAGES.EDIT_ALLOCATION && window.location.pathname.includes('edit-allocation')) {
      return true;
    }
    if (p === window.location.pathname) {
      return true;
    }
    return false;
  });
};

const ProtectedRouteRender = ({
  component: Component,
  isAuth,
  redirectTo,
  role,
  isUserPath,
  isCompanyPath,
  selectedWorkspace,
  path,
  ...rest
}): JSX.Element => {
  if (!isAuth) {
    return <Redirect to={{ pathname: redirectTo ?? PAGES.SIGN_IN }} />;
  }

  if (role === ACCOUNT_ROLES.MULTIUSER && path !== PAGES.CHOOSE_ACCOUNT_TYPE) {
    return <Redirect to={{ pathname: PAGES.CHOOSE_ACCOUNT_TYPE }} />;
  }

  if (role === ACCOUNT_ROLES.COMPANY && isUserPath) {
    return <Redirect to={{ pathname: PAGES.WORKSPACES_MANAGEMENT }} />;
  }

  if (role === ACCOUNT_ROLES.USER && isCompanyPath) {
    return <Redirect to={{ pathname: selectedWorkspace ? PAGES.DASHBOARD : PAGES.WORKSPACES_CHOOSE }} />;
  }

  if (role === ACCOUNT_ROLES.USER && !selectedWorkspace && path !== PAGES.WORKSPACES_CHOOSE) {
    return <Redirect to={{ pathname: PAGES.WORKSPACES_CHOOSE }} />;
  }

  if (
    role === ACCOUNT_ROLES.USER &&
    selectedWorkspace &&
    selectedWorkspace?.access_mode === ACCESS_MODE.VIEWER &&
    isRestrictedPath()
  ) {
    return <Redirect to={{ pathname: PAGES.DASHBOARD }} />;
  }

  return <Component {...rest} />;
};

interface ProtectedRouteProps {
  component;
  role: ACCOUNT_ROLES;
  isAuth: boolean;
  exact: boolean;
  path: string;
  isUserPath: boolean;
  isCompanyPath: boolean;
  selectedWorkspace: TUserWorkspace | null;
  redirectTo?;
}

const ProtectedRoute = ({
  component,
  isAuth,
  path,
  exact,
  redirectTo,
  isUserPath,
  isCompanyPath,
  role,
  selectedWorkspace,
  ...rest
}: ProtectedRouteProps): JSX.Element => {
  return (
    <Route
      {...rest}
      path={path}
      exact={exact}
      render={(props) => (
        <ProtectedRouteRender
          component={component}
          isAuth={isAuth}
          role={role}
          redirectTo={redirectTo}
          isUserPath={isUserPath}
          isCompanyPath={isCompanyPath}
          selectedWorkspace={selectedWorkspace}
          path={path}
          {...props}
        />
      )}
    />
  );
};

export default ProtectedRoute;
